// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import * as XLSX from "xlsx";
// import useApi from "../../../CustomHooks/useApi";
// import { Search } from "lucide-react";
// import { getDisplayDate } from "../../../ResuableCompoment/GetDisplayDate";
// import DynamicTable from "../../../ResuableCompoment/DynamicTable";

// const PAGE_SIZE = 20;

// const getToday = () => new Date().toISOString().split("T")[0];

// /* ─── status badge ─── */
// const StatusBadge = ({ v }) => (
//   <span
//     className={`px-3 py-1 rounded-full text-xs font-semibold
//       ${v === "SUCCESS"  ? "bg-emerald-100 text-emerald-700"
//       : v === "PENDING"  ? "bg-amber-100   text-amber-700"
//       : v === "FAILED"   ? "bg-rose-100    text-rose-700"
//       :                    "bg-gray-100    text-gray-600"}`}
//   >
//     {v || "—"}
//   </span>
// );

// const FinkedaHistory = () => {
//   const mid = useSelector((s) => s.auth.employeeDetails?.username);

//   const { callApi: fetchHistory } = useApi("/pg/finkeda/history", "GET");

//   /* ── state ── */
//   const [records,   setRecords]   = useState([]);
//   const [loading,   setLoading]   = useState(false);
//   const [fromDate,  setFromDate]  = useState(getToday());
//   const [toDate,    setToDate]    = useState(getToday());
//   const [searchTerm, setSearchTerm] = useState("");
//   const [page,      setPage]      = useState(0);          // 0-based (API)
//   const [totalPages, setTotalPages] = useState(0);
//   const [totalElements, setTotalElements] = useState(0);

//   /* ── columns ── */
//   const columns = [
//     {
//       key: "createdAt",
//       label: "Date",
//       render: (v) => getDisplayDate(v) || v || "—",
//     },
//     {
//       key: "finkedaTransactionId",
//       label: "Txn ID",
//       render: (v) => (
//         <span className="font-mono text-xs text-slate-700">{v || "—"}</span>
//       ),
//     },
//     {
//       key: "senderName",
//       label: "Sender Name",
//       render: (v) => v || "—",
//     },
//     {
//       key: "pgType",
//       label: "Plan (PG Type)",
//       render: (v) =>
//         v ? (
//           <span className="px-2 py-0.5 bg-purple-100 text-purple-700 rounded-full text-xs font-bold font-mono">
//             {v}
//           </span>
//         ) : "—",
//     },
//     {
//       key: "cardType",
//       label: "Card Type",
//       render: (v) => v || "—",
//     },
//     {
//       key: "cardNetwork",
//       label: "Network",
//       render: (v) => v || "—",
//     },
//     {
//       key: "amount",
//       label: "Amount",
//       render: (v) => (
//         <span className="font-semibold text-slate-800">
//           ₹{Number(v || 0).toFixed(2)}
//         </span>
//       ),
//     },
//     {
//       key: "txnStatus",
//       label: "Status",
//       render: (v) => <StatusBadge v={v} />,
//     },
//   ];

//   /* ── fetch ── */
//   const load = async (pg = 0) => {
//     setLoading(true);
//     try {
//       let query = `?mid=${mid}&page=${pg}&size=${PAGE_SIZE}`;
//       if (fromDate) query += `&fromDate=${fromDate}`;
//       if (toDate)   query += `&toDate=${toDate}`;

//       const res  = await fetchHistory(null, query);
//       const data = res?.data ?? res;

//       /* handle paginated response { content, totalPages, totalElements }
//          or plain array */
//       if (Array.isArray(data)) {
//         setRecords(data);
//         setTotalPages(1);
//         setTotalElements(data.length);
//       } else {
//         setRecords(data?.content ?? data?.data ?? []);
//         setTotalPages(data?.totalPages ?? 1);
//         setTotalElements(data?.totalElements ?? 0);
//       }
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => { load(0); }, []); // eslint-disable-line react-hooks/exhaustive-deps

//   /* ── client-side search across current page ── */
//   const filtered = records.filter((row) =>
//     Object.values(row).some((val) =>
//       String(val ?? "").toLowerCase().includes(searchTerm.toLowerCase())
//     )
//   );

//   /* ── handlers ── */
//   const handleApply = () => { setPage(0); load(0); };

//   const handlePageChange = (next) => {
//     const p = Math.max(0, Math.min(next, totalPages - 1));
//     setPage(p);
//     load(p);
//   };

//   /* ── excel export ── */
//   const downloadExcel = () => {
//     const rows = records.map((r) => ({
//       Date:       r.createdAt,
//       TxnID:      r.txnId,
//       SenderName: r.senderName,
//       PGType:     r.pgType,
//       CardType:   r.cardType,
//       Network:    r.cardNetwork,
//       Amount:     r.amount,
//       Status:     r.status,
//     }));
//     const ws = XLSX.utils.json_to_sheet(rows);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Finkeda History");
//     XLSX.writeFile(wb, "Finkeda_PG_History.xlsx");
//   };

//   const displayPage = page + 1; // 1-based for display

//   /* ══════════════════════════════════════════ */
//   return (
//     <div className="min-h-screen p-6 bg-[#EEF1F5]">

//       {/* ── title ── */}
//       <div className="mb-6">
//         <h1 className="text-3xl font-bold text-[#0A2A4F]">
//          PG Bank History
//         </h1>
//         <p className="text-sm text-gray-600 mt-1">
//           Payment Gateway transaction records
//         </p>
//       </div>

//       {/* ── filters ── */}
//       <div className="bg-white rounded-2xl shadow-sm border p-6 mb-8">
//         <div className="flex flex-wrap items-center gap-4">

//           {/* search */}
//           <div className="relative w-full md:w-80">
//             <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
//             <input
//               type="text"
//               placeholder="Search by Txn ID, status…"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="w-full pl-10 pr-4 h-10 rounded-lg border focus:border-[#0A2A4F] focus:outline-none"
//             />
//           </div>

//           {/* from date */}
//           <input
//             type="date"
//             value={fromDate}
//             onChange={(e) => setFromDate(e.target.value)}
//             className="h-10 px-3 border rounded-lg bg-gray-50"
//           />

//           {/* to date */}
//           <input
//             type="date"
//             value={toDate}
//             min={fromDate}
//             onChange={(e) => setToDate(e.target.value)}
//             className="h-10 px-3 border rounded-lg bg-gray-50"
//           />

//           {/* apply */}
//           <button
//             onClick={handleApply}
//             className="h-10 px-5 rounded-lg bg-indigo-600 text-white font-semibold hover:bg-indigo-700 transition"
//           >
//             Apply
//           </button>

//           {/* excel */}
//           <button
//             onClick={downloadExcel}
//             disabled={records.length === 0}
//             className="h-10 px-6 rounded-lg bg-green-600 text-white font-semibold shadow hover:bg-green-700 transition disabled:opacity-50"
//           >
//             Download Excel
//           </button>

//           {/* total badge */}
//           {totalElements > 0 && (
//             <span className="ml-auto text-sm text-gray-500 font-medium">
//               Total: <b className="text-[#0A2A4F]">{totalElements}</b> records
//             </span>
//           )}

//         </div>
//       </div>

//       {/* ── table ── */}
//       <div className="bg-white rounded-2xl shadow-md">
//         <DynamicTable
//           columns={columns}
//           data={filtered}
//           isLoading={loading}
//           emptyText="No Finkeda PG records found"
//         />
//       </div>

//       {/* ── server-side pagination ── */}
//       {totalPages > 1 && (
//         <div className="mt-6 flex flex-wrap items-center justify-between text-sm text-gray-600">

//           <span>
//             Page <b>{displayPage}</b> of <b>{totalPages}</b>
//             {totalElements > 0 && (
//               <span className="ml-2 text-gray-400">({totalElements} total)</span>
//             )}
//           </span>

//           <div className="flex items-center gap-2">

//             <button
//               disabled={page === 0 || loading}
//               onClick={() => handlePageChange(0)}
//               className="px-3 py-2 rounded-lg bg-gray-200 text-gray-700 disabled:opacity-40 text-xs font-semibold"
//             >
//               « First
//             </button>

//             <button
//               disabled={page === 0 || loading}
//               onClick={() => handlePageChange(page - 1)}
//               className="px-4 py-2 rounded-lg bg-gray-200 text-gray-700 disabled:opacity-40"
//             >
//               Previous
//             </button>

//             {/* page number pills */}
//             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//               const start = Math.max(0, Math.min(page - 2, totalPages - 5));
//               const p = start + i;
//               return (
//                 <button
//                   key={p}
//                   onClick={() => handlePageChange(p)}
//                   className={`w-9 h-9 rounded-lg text-sm font-bold transition
//                     ${p === page
//                       ? "bg-[#0A2A4F] text-white"
//                       : "bg-gray-100 text-gray-600 hover:bg-gray-200"}`}
//                 >
//                   {p + 1}
//                 </button>
//               );
//             })}

//             <button
//               disabled={page >= totalPages - 1 || loading}
//               onClick={() => handlePageChange(page + 1)}
//               className="px-4 py-2 rounded-lg bg-[#0A2A4F] text-white disabled:opacity-40"
//             >
//               Next
//             </button>

//             <button
//               disabled={page >= totalPages - 1 || loading}
//               onClick={() => handlePageChange(totalPages - 1)}
//               className="px-3 py-2 rounded-lg bg-[#0A2A4F] text-white disabled:opacity-40 text-xs font-semibold"
//             >
//               Last »
//             </button>

//           </div>
//         </div>
//       )}

//     </div>
//   );
// };

// export default FinkedaHistory;


import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";
import useApi from "../../../CustomHooks/useApi";
import { 
  Search, 
  FileSpreadsheet, 
  Landmark, 
  RotateCw, 
  CheckCircle2, 
  XCircle, 
  Clock, 
  ChevronLeft, 
  ChevronRight,
  CreditCard
} from "lucide-react";
import { getDisplayDate } from "../../../ResuableCompoment/GetDisplayDate";
import DynamicTable from "../../../ResuableCompoment/DynamicTable";

const PAGE_SIZE = 20;

const getToday = () => new Date().toISOString().split("T")[0];

/* ─── status badge ─── */
const StatusBadge = ({ v }) => {
  const status = (v || "").toUpperCase();
  if (status === "SUCCESS") {
    return (
      <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200">
        <CheckCircle2 className="w-3 h-3" /> SUCCESS
      </span>
    );
  }
  if (status === "FAILED" || status === "FAILURE") {
    return (
      <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-semibold bg-rose-50 text-rose-700 border border-rose-200">
        <XCircle className="w-3 h-3" /> FAILED
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-semibold bg-amber-50 text-amber-700 border border-amber-200">
      <Clock className="w-3 h-3" /> {status || "PENDING"}
    </span>
  );
};

const FinkedaHistory = () => {
  const mid = useSelector((s) => s.auth.employeeDetails?.username);

  const { callApi: fetchHistory } = useApi("/pg/finkeda/history", "GET");

  /* ── state ── */
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState(getToday());
  const [toDate, setToDate] = useState(getToday());
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0); // 0-based (API)
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);

  /* ── columns ── */
  const columns = [
    {
      key: "createdAt",
      label: "Date",
      render: (v) => getDisplayDate(v) || v || "—",
    },
    {
      key: "finkedaTransactionId",
      label: "Txn ID",
      render: (v) => (
        <span className="font-mono text-slate-700 bg-slate-100/70 px-2 py-0.5 rounded-md border border-slate-200/50 text-xs">
          {v || "—"}
        </span>
      ),
    },
    {
      key: "senderName",
      label: "Sender Name",
      render: (v) => (
        <span className="font-semibold text-slate-800">
          {v || "—"}
        </span>
      ),
    },
    {
      key: "pgType",
      label: "Plan (PG Type)",
      render: (v) =>
        v ? (
          <span className="px-2.5 py-0.5 bg-purple-50 text-purple-700 border border-purple-200 rounded-full text-xs font-bold font-mono">
            {v}
          </span>
        ) : "—",
    },
    {
      key: "cardType",
      label: "Card Type",
      render: (v) => (
        <span className="text-slate-600 font-medium">
          {v || "—"}
        </span>
      ),
    },
    {
      key: "cardNetwork",
      label: "Network",
      render: (v) => (
        <span className="font-mono text-slate-600 uppercase text-xs">
          {v || "—"}
        </span>
      ),
    },
    {
      key: "amount",
      label: "Amount",
      render: (v) => (
        <span className="font-bold text-slate-900 text-sm">
          ₹{Number(v || 0).toFixed(2)}
        </span>
      ),
    },
    {
      key: "txnStatus",
      label: "Status",
      render: (v) => <StatusBadge v={v} />,
    },
  ];

  /* ── fetch ── */
  const load = async (pg = 0) => {
    setLoading(true);
    try {
      let query = `?mid=${mid}&page=${pg}&size=${PAGE_SIZE}`;
      if (fromDate) query += `&fromDate=${fromDate}`;
      if (toDate) query += `&toDate=${toDate}`;

      const res = await fetchHistory(null, query);
      const data = res?.data ?? res;

      if (Array.isArray(data)) {
        setRecords(data);
        setTotalPages(1);
        setTotalElements(data.length);
      } else {
        setRecords(data?.content ?? data?.data ?? []);
        setTotalPages(data?.totalPages ?? 1);
        setTotalElements(data?.totalElements ?? 0);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { 
    load(0); 
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  /* ── client-side search across current page ── */
  const filtered = records.filter((row) =>
    Object.values(row).some((val) =>
      String(val ?? "").toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  /* ── handlers ── */
  const handleApply = () => { 
    setPage(0); 
    load(0); 
  };

  const handlePageChange = (next) => {
    const p = Math.max(0, Math.min(next, totalPages - 1));
    setPage(p);
    load(p);
  };

  /* ── excel export ── */
  const downloadExcel = () => {
    const rows = records.map((r) => ({
      Date: r.createdAt,
      TxnID: r.txnId,
      SenderName: r.senderName,
      PGType: r.pgType,
      CardType: r.cardType,
      Network: r.cardNetwork,
      Amount: r.amount,
      Status: r.status,
    }));
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Finkeda History");
    XLSX.writeFile(wb, "Finkeda_PG_History.xlsx");
  };

  const displayPage = page + 1; // 1-based for display

  return (
    <div className="space-y-6">
      {/* ================= SECTION HEADER ================= */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-blue-50 text-blue-700 border border-blue-100 mb-2">
            <Landmark className="w-3.5 h-3.5" />
            PG Bank Processing History
          </div>
          <h2 className="text-xl sm:text-2xl font-bold text-slate-800 tracking-tight">
            PG Bank History
          </h2>
          <p className="text-xs text-slate-500 font-medium mt-0.5">
            Real-time tracking of payment gateway bank logs, card networks, and sender audit history
          </p>
        </div>
      </div>

      {/* ================= FILTER & SEARCH BAR ================= */}
      <div className="bg-white rounded-3xl p-5 border border-slate-200/80 shadow-xs space-y-4">
        <div className="flex flex-wrap items-center justify-between gap-4">
          
          {/* Search Box */}
          <div className="relative w-full sm:w-80">
            <Search className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              type="text"
              placeholder="Search Txn ID, Sender, Status..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2.5 bg-slate-50 border border-slate-200/80 focus:border-blue-500 focus:bg-white rounded-xl text-xs font-semibold text-slate-700 placeholder-slate-400 outline-hidden transition"
            />
          </div>

          {/* Date Picker & Action Buttons */}
          <div className="flex flex-wrap items-center gap-2.5 w-full sm:w-auto">
            <div className="flex items-center gap-2">
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="h-10 px-3 bg-slate-50 border border-slate-200/80 focus:border-blue-500 focus:bg-white rounded-xl text-xs font-semibold text-slate-700 outline-hidden transition"
              />
              <span className="text-slate-400 text-xs font-bold">to</span>
              <input
                type="date"
                value={toDate}
                min={fromDate}
                onChange={(e) => setToDate(e.target.value)}
                className="h-10 px-3 bg-slate-50 border border-slate-200/80 focus:border-blue-500 focus:bg-white rounded-xl text-xs font-semibold text-slate-700 outline-hidden transition"
              />
            </div>

            <button
              onClick={handleApply}
              disabled={loading}
              className="h-10 px-4 rounded-xl bg-slate-900 hover:bg-slate-800 text-white font-bold text-xs shadow-md shadow-slate-900/10 transition active:scale-95 flex items-center gap-1.5 cursor-pointer"
            >
              <RotateCw className={`w-3.5 h-3.5 ${loading ? "animate-spin" : ""}`} />
              <span>Apply</span>
            </button>

            <button
              onClick={downloadExcel}
              disabled={records.length === 0}
              className="h-10 px-4 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-xs shadow-md shadow-emerald-600/15 transition active:scale-95 flex items-center gap-1.5 cursor-pointer disabled:opacity-50"
            >
              <FileSpreadsheet className="w-3.5 h-3.5" />
              <span>Excel</span>
            </button>
          </div>
        </div>

        {/* Count Preview Bar */}
        <div className="pt-2 border-t border-slate-100 flex items-center justify-between text-xs text-slate-500 font-medium">
          <span>
            Showing <strong className="text-slate-800">{filtered.length}</strong> of{" "}
            <strong className="text-slate-800">{totalElements}</strong> total records
          </span>
          <span>
            Page <strong className="text-blue-600 font-bold">{displayPage}</strong> of{" "}
            <strong>{totalPages || 1}</strong>
          </span>
        </div>
      </div>

      {/* ================= TABLE CONTAINER ================= */}
      <div className="bg-white rounded-3xl border border-slate-200/80 shadow-xs p-2 sm:p-4">
        <DynamicTable
          columns={columns}
          data={filtered}
          isLoading={loading}
          emptyText="No Finkeda PG records found for the selected range"
        />

        {/* ================= SERVER-SIDE PAGINATION CONTROLS ================= */}
        {totalPages > 1 && (
          <div className="mt-4 pt-3 border-t border-slate-100 flex flex-wrap items-center justify-between gap-4 text-xs font-semibold text-slate-600 px-2">
            <span>
              Page {displayPage} of {totalPages}
            </span>

            <div className="flex items-center gap-1.5">
              <button
                disabled={page === 0 || loading}
                onClick={() => handlePageChange(0)}
                className="px-2.5 py-1.5 rounded-xl border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 disabled:opacity-40 transition active:scale-95 text-xs font-semibold"
              >
                First
              </button>

              <button
                disabled={page === 0 || loading}
                onClick={() => handlePageChange(page - 1)}
                className="px-3 py-1.5 rounded-xl border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 disabled:opacity-40 transition active:scale-95 flex items-center gap-1"
              >
                <ChevronLeft className="w-3.5 h-3.5" />
                <span>Prev</span>
              </button>

              {/* Dynamic Number Pills */}
              <div className="hidden sm:flex items-center gap-1">
                {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                  const start = Math.max(0, Math.min(page - 2, totalPages - 5));
                  const p = start + i;
                  return (
                    <button
                      key={p}
                      onClick={() => handlePageChange(p)}
                      className={`w-8 h-8 rounded-xl text-xs font-bold transition ${
                        p === page
                          ? "bg-slate-900 text-white shadow-sm"
                          : "bg-slate-50 text-slate-600 hover:bg-slate-100 border border-slate-200/60"
                      }`}
                    >
                      {p + 1}
                    </button>
                  );
                })}
              </div>

              <button
                disabled={page >= totalPages - 1 || loading}
                onClick={() => handlePageChange(page + 1)}
                className="px-3 py-1.5 rounded-xl bg-slate-900 hover:bg-slate-800 text-white disabled:opacity-40 transition active:scale-95 flex items-center gap-1"
              >
                <span>Next</span>
                <ChevronRight className="w-3.5 h-3.5" />
              </button>

              <button
                disabled={page >= totalPages - 1 || loading}
                onClick={() => handlePageChange(totalPages - 1)}
                className="px-2.5 py-1.5 rounded-xl border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 disabled:opacity-40 transition active:scale-95 text-xs font-semibold"
              >
                Last
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FinkedaHistory;